import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging';
import { db } from './firebase';
import { doc, updateDoc } from 'firebase/firestore';
import { app } from './firebase';

const VAPID_KEY = 'BPl9EWIfqOPgoVVIjThAnFfhrk6ODjEtDME3V1uZVV64YH7sCbH0Vf4QeYnK3BsgInqaBHycqbLPkw5adR186lU'; // your full VAPID key

let messaging = null;

const initMessaging = async () => {
  try {
    const supported = await isSupported();
    if (supported) {
      messaging = getMessaging(app);
    }
  } catch (e) {
    console.log('Messaging not supported:', e);
  }
};

initMessaging();

export async function requestNotificationPermission(userId) {
  try {
    const supported = await isSupported();
    if (!supported) return null;
    const permission = await Notification.requestPermission();
    if (permission === 'granted' && messaging) {
      const token = await getToken(messaging, { vapidKey: VAPID_KEY });
      if (token && userId) {
        await updateDoc(doc(db, 'users', userId), {
          fcmToken: token,
          notificationsEnabled: true,
        });
      }
      return token;
    }
  } catch (err) {
    console.log('Notification permission error:', err);
  }
  return null;
}

export function onForegroundMessage(callback) {
  if (!messaging) return () => {};
  try {
    return onMessage(messaging, callback);
  } catch (e) {
    console.log('onMessage error:', e);
    return () => {};
  }
}